import React from "react";
import RatesDashboardDatepicker from "./RatesDashboardDatepicker";
import RatesDashboardToggles from "./RatesDashboardToggles";
import RatesDashboardHeatMapLegend from "./RatesDashboardHeatMapLegend";
import RatesDashboardHeader from "./RatesDashboardHeader";
import RatesDashboardSidebar from "./RatesDashboardSidebar";
import RatesDashboardDateGrid from "./RatesDashboardDateGrid";
import DateHelper from "../DateHelper/DateHelper";
import { addDays } from "date-fns";

class RatesDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      heatMapColors: [
        "#336633",
        "#339933",
        "#33CC33",
        "#FFE102",
        "#FF9000",
        "#FF5000",
        "#A00000",
      ],
      start_date: DateHelper.parseDateFromBackend(this.props.start_date),
      todays_date: DateHelper.parseDateFromBackend(this.props.todays_date),
      end_date: DateHelper.parseDateFromBackend(this.props.end_date),
      tempDateView: this.props.dateView,
      tempStartDate: DateHelper.parseDateFromBackend(this.props.start_date),
      dateView: this.props.dateView,
      dailyRoomTypes: this.props.dailyRoomTypes,
      room_types: this.props.room_types,
      roomTypeRates: {},
      toggleSetting: "prices",
      newPricingAlgorithm: true,
    };

    this.getDailyRates = this.getDailyRates.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeDateView = this.onChangeDateView.bind(this);
    this.onExpandCollapseRoomType = this.onExpandCollapseRoomType.bind(this);
    this.onChangeToggle = this.onChangeToggle.bind(this);
  }

  componentDidMount() {
    var self = this;
    var $RatesDashboard = $('#RatesDashboardWrapper');

    $RatesDashboard.on("scroll", function () {
      var scrollLeft = $RatesDashboard.scrollLeft();
      var scrollTop = $RatesDashboard.scrollTop();

      // position sticky divs
      $RatesDashboard.find(".RatesDashboardHeader").css({ top: scrollTop });
      $RatesDashboard
        .find(".RatesDashboardHeaderCover")
        .css({ top: scrollTop, left: scrollLeft });
      $RatesDashboard.find(".RatesDashboardSidebar").css({ left: scrollLeft });

      // hide any open tooltips
      $RatesDashboard.find(".tooltip").tooltip("hide");
    });

    $(window).on("refresh_data_table", function () {
      self.getDailyRates(self.state.start_date, self.state.end_date);
    });
  }

  /**
   * Render functions
   */

  render() {
    console.log("this.state.dailyRoomTypes", this.state.dailyRoomTypes);
    
    return (
      <div className="RatesDashboardWrapper" id="RatesDashboardWrapper">
        <RatesDashboardDatepicker
          {...this.props}
          {...this.state}
          onChangeDate={this.onChangeDate}
          onChangeDateView={this.onChangeDateView}
        />
        <RatesDashboardToggles
          {...this.props}
          {...this.state}
          onChangeToggle={this.onChangeToggle}
        />

        <div
          className={"RatesDashboard " + this.state.dateView}
        >
          <div className="RatesDashboardHeaderCover">&nbsp;</div>
          <RatesDashboardHeader {...this.props} {...this.state} />
          <RatesDashboardSidebar
            {...this.props}
            {...this.state}
            onExpandCollapseRoomType={this.onExpandCollapseRoomType}
          />
          <RatesDashboardDateGrid {...this.props} {...this.state} />
        </div>

        <RatesDashboardHeatMapLegend heatMapColors={this.state.heatMapColors} />
        {this.state.loading ? (
          <div className="loadingOverlay">
            <div className="spinner"></div>
          </div>
        ) : null}
      </div>
    );
  }

  /**
   * Change handlers
   */

  onChangeDate(date, e) {
    var self = this;

    if (e && e.preventDefault && e.stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }

    var start_date = date;
    var end_date = date;

    if (this.state.dateView === "week") {
      end_date = addDays(end_date, 7);
    } else if (this.state.dateView === "month") {
      end_date = addDays(end_date, 31);
    }

    this.setState({ tempStartDate: start_date }, function () {
      self.getDailyRates(start_date, end_date);
    });
  }

  onChangeDateView(dateView) {
    var self = this;
    var start_date = new Date(this.state.start_date);
    var end_date = new Date(this.state.start_date);
    if (dateView === "week") {
      end_date = addDays(end_date, 7);
    } else {
      end_date = addDays(end_date, 31);
    }
    this.setState({ tempDateView: dateView }, function () {
      self.getDailyRates(start_date, end_date);
    });
  }

  onChangeToggle(e) {
    this.setState({ toggleSetting: e.target.value }, this.getDailyRates);
    // this.setState({ toggleSetting: e.target.value }, this.getDailyRoomTypeRates);

  }

  onExpandCollapseRoomType(room_type, collapsed) {
    if (!collapsed) {
      if (this.state.roomTypeRates[room_type.id] && this.state.roomTypeRates[room_type.id].length > 0) {
        // we have rates for this room type
      } else {
        this.getDailyRoomTypeRates(room_type.id);
      }
    }

    var room_types = JSON.parse(JSON.stringify(this.state.room_types));
    for (var i = 0, ilen = room_types.length; i < ilen; i++) {
      if (room_types[i].id === room_type.id) {
        room_types[i].collapsed = collapsed;
        break;
      }
    }

    this.setState({ room_types: room_types });
  }

  /**
   * Helper functions
   */

  getDailyRates(start_date, end_date) {
    
    var page_url = this.props.ratesDashboardPath;
    page_url = page_url.replace(/\:date_view/, this.state.tempDateView);
    page_url = page_url.replace(
      /\:start_date/,
      (start_date || this.state.start_date).toISOString().split("T")[0]
    );
    history.replaceState({}, document.title, page_url);

    var room_types = JSON.parse(JSON.stringify(this.state.room_types));
    for (var i = 0, ilen = room_types.length; i < ilen; i++) {
      room_types[i].collapsed = true;
    }

    this.setState({ loading: true, room_types: room_types, roomTypeRates: {} });
    // console.log("about to gather rates", this.state);
    
    $.ajax({
      type: "POST",
      url: this.props.dailyRatesPath,
      data: {
        start_date: start_date || this.state.start_date,
        end_date: end_date || this.state.end_date,
        price_or_minimum_stay: this.state.toggleSetting,
      },
    }).done((data) => {
      this.setState(
        {
          start_date: start_date || this.state.start_date,
          end_date: end_date || this.state.end_date,
          dateView: this.state.tempDateView,
          dailyRoomTypes: data.daily_room_types,
          room_types: data.room_types,
          loading: false,
        },
        () => {
          var $tbody = $('#RatesDashboardWrapper').find("table tbody");
          $tbody.scrollLeft(0).scrollTop(0).trigger("scroll");
        }
      );
    });
  }

  getDailyRoomTypeRates(room_type_id, start_date, end_date) {
    $.ajax({
      type: "POST",
      url: this.props.daily_room_type_rates_path,
      data: {
        room_type_id: room_type_id,
        start_date: start_date || this.state.start_date,
        end_date: end_date || this.state.end_date,
        price_or_minimum_stay: this.state.toggleSetting,
      },
    }).done((data) => {
      var { roomTypeRates } = this.state;
      roomTypeRates[room_type_id] = data.daily_room_type_rates;
      this.setState({roomTypeRates: roomTypeRates}, () => {
        var $tbody = $('#RatesDashboardWrapper').find("table tbody");
        $tbody.scrollLeft(0).scrollTop(0).trigger("scroll");
      });
    });
  }  
}

export default RatesDashboard;
